export default {
    AdditionalPageTypes: true,
    Admin: true,
    Advertising: false,
    Advertising2: {
        adServers: ["simple"],
        adSizes: ["mpu", "banner", "banner-large"],
    },
    AggregatedContentFeed: true,
    AllowCustomFields: false,
    AppConfig: true,
    AppEcommerceManager: true,
    AppScorePredictor: false,
    AppSocialManager: true,
    AppTicketingManager: true,
    BreakingNews: true,
    BuildManager: true,
    Calendar: true,
    CustomCommentary: true,
    CustomLineups: true,
    CustomTables: true,
    CustomTags: false,
    Dashboard: true,
    Fixtures: true,
    Forms: true,
    HomepageManager: true,
    HomepageNewsPromo: false,
    HomepagePlayerHighlight: false,
    Lab: true,
    MapDirectory: true,
    MatchdayTakeover: true,
    Media: true,
    News: true,
    OptaIntegration: true,
    Organisations: false,
    OverlayPromos: true,
    Pages: true,
    PlatformOptions: true,
    PlayerVoting: true,
    PreventEntitlementEmails: false,
    Profile: true,
    RelatedContentTagging: true,
    RewardsManager: false,
    RewardPoints: false,
    Rover: false,
    Settings: false,
    SiteConfig: true,
    SocialContentFeed: true,
    Sponsors: true,
    Squads: true,
    SsoUsers: true,
    StreamAMGIntegration: false,
    Streamline: true,
    StreamlineAdverts: false,
    StreamlineAutoSubtitles: true,
    StreamlinePromoCodes: false,
    Videos: true,
    Voice: false,
    WebStats: true,
};
